const validate = values => {
    const errors = {}
    const requiredFields = [
        'typeId',
        'title',
        'expirationDate',
        'content'
    ]

    requiredFields.forEach(field => {
        if (!values[field]) {
            errors[field] = 'fieldRequired'
        }
    })

    return errors
}

export default validate

//const validate = values => {
//    const errors = {}
//    const requiredFields = [
//        'typeId',
//        'title',
//        'expirationDate',
//        'content'
//    ]

//    requiredFields.forEach(field => {
//        if (!values[field]) {
//            errors[field] = 'Полето е задължително'
//        }
//    })
    
//    return errors
//}

//export default validate